import {
  Identifiable,
  Project,
  ProjectReport,
  projectReportField,
} from "@planzone/dto";
import { HttpClient, HttpMethods } from "../types/httpClient";

function removeProjectReport(httpClient: HttpClient) {
  return (
    project: Identifiable<Project>,
    reportToRemove: Identifiable<ProjectReport>,
  ) =>
    httpClient.sendHttpRequest<void>({
      endpoint: `/projects/${project.uuid}`,
      method: HttpMethods.PATCH,
      data: {
        data: Object.values(reportToRemove.fields).reduce(
          (report, field) => ({
            ...report,
            [`reports.${reportToRemove.uuid}.fields.${field.name}.name`]: "",
            [`reports.${reportToRemove.uuid}.fields.${field.name}.type`]: "",
            [`reports.${reportToRemove.uuid}.fields.${field.name}.value`]: "",
            [`reports.${reportToRemove.uuid}.fields.${field.name}.order`]: "",
          }),
          {
            [`reports.${reportToRemove.uuid}.uuid`]: "",
            [`reports.${reportToRemove.uuid}.name`]: "",
            [`reports.${reportToRemove.uuid}.author`]: "",
            [`reports.${reportToRemove.uuid}.submissionDate`]: "",
            [`reports.${reportToRemove.uuid}.templateId`]: "",
          },
        ),
      },
    });
}

export { removeProjectReport };
